export { };

declare global {
	interface String {
		getStringFromHtml: () => string;
	}
}
String.prototype.getStringFromHtml = function (): string {
	const div = document.createElement('div');
	div.innerHTML = this.replace(/\n/g, '').replace(/<br(\s+\/)?>/g, '\n').replace(/<\/(p|div)>/g, '</$1>\n');
	return div.textContent ?? div.innerText;
};
